import { fromJS } from 'immutable'
import {
  TEAM_EDIT_REQUEST,
  TEAM_EDIT_SUCCESS,
  TEAM_EDIT_FAILURE,
  TEAM_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TEAM_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case TEAM_EDIT_SUCCESS:
      return state
        .set('teamEdit', fromJS(action.payload.updatedTeam))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case TEAM_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('teamEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case TEAM_EDIT_RESET:
      return state
        .delete('teamEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/team/team-edit-reducer.js